import { getStream } from '../base/selectors';
function getCursorStream(state, streamId) {
    return getStream(state, streamId);
}
export const getCursor = (state, streamId)=>getCursorStream(state, streamId).cursor;
export const getPrevCursor = (state, streamId)=>getCursorStream(state, streamId).prevCursor;

//# sourceMappingURL=selectors.js.map